import { render, staticRenderFns } from "./EmailNotVerified.vue?vue&type=template&id=edae0acc&scoped=true&"
import script from "./EmailNotVerified.vue?vue&type=script&lang=js&"
export * from "./EmailNotVerified.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotVerified.vue?vue&type=style&index=0&id=edae0acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edae0acc",
  null
  
)

export default component.exports